import * as angular from 'angular';
import { ModalService } from './modal.service';
import { ModalDialogLinkComponent } from './modal-dialog-link/modal-dialog-link.component';
import { ModalDialogComponent } from './modal-dialog/modal-dialog.component';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { AvatarComponent } from './avatar/avatar-component';
import { CopyToClipboardDirective } from './directives/copy-to-clipboard-directive';
import { TableListModule } from './table-list/table-list.module';
import { SelectFieldModule } from './select-field/select-field.module';
import { SchedulesModalDirective } from './modal-schedules/schedules-modal-directive';
import { SchedulesModalService } from './modal-schedules/schedules-modal.service';

/* prettier-ignore */
export const SharedUiAngularjsModule = angular
  .module('shared-ui-angularjs', [
    'ui.bootstrap.modal',
    TableListModule,
    SelectFieldModule
  ])
  .service('ModalService', ModalService)
  .component('modalDialogLink', ModalDialogLinkComponent)
  .component('modalDialog', ModalDialogComponent)
  .component('modeAvatar', AvatarComponent)
  .component('svgIcon', SvgIconComponent)
  .directive('copyToClipboard', CopyToClipboardDirective)
  .directive('schedulesModal', SchedulesModalDirective)
  .service('SchedulesModalService', SchedulesModalService)
  .name;
